// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"22":"7a1bff3b","207":"ace9d7f9","362":"581cafc3","937":"5ec10476","941":"b21a0b4e","951":"1711ec41"}[chunkId] + ".css";
};